import "./contact.css";
import Sofa from "../../img/sofa.jpg";



import { useContext, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { ThemeContext } from "../../context";
import { Navigate } from "react-router-dom";


const Contact = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false)
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "web_Portafolio",
        "template_7sefs1f",
        formRef.current,
        "qI6eJ_2NBW4uiQ7GR"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true)
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="c">
      
      <div className="c-wrapper">
        <div className="c-left">
        <img className="sofa" src={Sofa} alt="sofa" />
        </div>
        <div className="c-right">
          <p className="c-desc">
        
            <b>Get in touch... Always available for freelancing! (or not)</b> 
            
          </p>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Name" name="user_name" />
            {/* <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Subject" name="user_subject" /> */}
            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Email" name="user_email" />
            <textarea style={{backgroundColor: darkMode && "#333"}} rows="5" placeholder="Message" name="message" />
            <button>Submit</button>
            {done &&  <Navigate to="/enviado" />}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
